import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IDocumentSettings } from 'types';
import { ALLERGEN_SETTING_KEY, TERMS_SETTING_KEY } from 'appConstants';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './DocumentSettings.module.scss';

interface IComponentDocumentSettings {
	data: IDocumentSettings;
}

const DocumentSettings: React.FC<IComponentDocumentSettings> = ({ data }) => {
	const { selectedStyleGroup } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const headingElement = useRef<null | HTMLDivElement>(null);
	const { t } = useTranslation('mediaSettings');
	const isCheckedGoingToMenu = data.allergensShowCondition === 'GoingToMenu';
	const goingToMenuInputValue = t('showWhenGoingToMenuLabel');
	const isChoosingDishToMenu = data.allergensShowCondition === 'ChoosingDish';
	const choosingDishInputValue = t('showWhenChoosingDishLabel');
	const isShowModalWindow = data.termsShowInModal || false;
	const showModalWindowInputValue = t('showModalWindowLabel');

	useEffect(() => {
		if (selectedStyleGroup?.id === data.id) {
			headingElement.current?.scrollIntoView({ behavior: 'smooth' });
		}
	}, [selectedStyleGroup]);

	return (
		<div ref={headingElement}>
			<Text
				className={style.heading}
				translationNameSpace="mediaSettings"
				translationKey={data.key}
				theme="secondary"
				size="l"
				weight="bold"
			/>
			<div className={style.contentWrapper}>
				<div className={style.content}>
					<BlobDownloader
						filePath={data.filePath}
						fileExtension="pdf"
						fileName={data.key?.toLowerCase() || ''}
						label="downloadFile"
					/>
				</div>
				<div className={style.content}>
					{data.key === ALLERGEN_SETTING_KEY && (
						<>
							<FullInfoField
								containerClassName={style.fullInfoField}
								value={goingToMenuInputValue}
								prefixIcon="asCheckbox"
								useInForm={true}
								prefixIconName={isCheckedGoingToMenu ? 'checkMark' : 'crossMark'}
								prefixIconIsChecked={isCheckedGoingToMenu}
							/>
							<FullInfoField
								value={choosingDishInputValue}
								prefixIcon="asCheckbox"
								useInForm={true}
								prefixIconName={isChoosingDishToMenu ? 'checkMark' : 'crossMark'}
								prefixIconIsChecked={isChoosingDishToMenu}
							/>
						</>
					)}
					{data.key === TERMS_SETTING_KEY && (
						<FullInfoField
							value={showModalWindowInputValue}
							prefixIcon="asCheckbox"
							useInForm={true}
							prefixIconName={isShowModalWindow ? 'checkMark' : 'crossMark'}
							prefixIconIsChecked={isShowModalWindow}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default DocumentSettings;
